import React, {
    forwardRef,
    useRef,
    useLayoutEffect,
    useCallback
} from "react";



import { Input } from "rsuite";

function withCursorRetention(Component) {
    return forwardRef(({ onChange, value, ...rest }, ref) => {
        const instanceRef = useRef(null);
        const combinedRef = ref || instanceRef;
        const elementRef = useRef(null);

        const posRef = useRef({ start: 0, end: 0 });

        const handleSelect = useCallback((e) => {
            posRef.current = {
                start: e.target.selectionStart,
                end: e.target.selectionEnd
            };
            elementRef.current = e.target;
        }, []);

        const handleChange = useCallback(
            (newVal, e) => {
                posRef.current = {
                    start: e.target.selectionStart,
                    end: e.target.selectionEnd
                };
                elementRef.current = e.target;
                onChange && onChange(newVal, e);
            },
            [onChange]
        );

        const handleKeyDown = useCallback(
            (e) => {
                const el = elementRef.current;
                if ((e.key === 'Delete' || e.key === 'Backspace') && el) {
                    const { selectionStart, selectionEnd } = el;
                    if (selectionStart !== null && selectionEnd !== null && selectionStart !== selectionEnd) {
                        // Clear entire selection
                        const newVal = '';
                        posRef.current = { start: 0, end: 0 };
                        elementRef.current = el;
                        onChange && onChange(newVal, e);
                        e.preventDefault();
                    }
                }
            },
            [onChange]
        );

        useLayoutEffect(() => {
            const el = elementRef.current;
            if (el === document.activeElement) {
                const { start, end } = posRef.current;
                try {
                    el.setSelectionRange(start, end);
                } catch {}
            }
        }, [value]);

        return (
            <Component
                {...rest}
                ref={combinedRef}
                value={value}
                onChange={handleChange}
                onSelect={handleSelect}
                onKeyDown={handleKeyDown}
            />
        );
    });
}

const InputWithCursor = withCursorRetention(Input);
export default InputWithCursor;
